<div class="clients-content">
    <div class="row">
        <div class="col-md-6">
            <h3 class="main-heading">Pick our Brain?</h3>
            <img src="assets/circile_rect.png" class="rec-img" alt="">
        </div>
        <div class="col-md-6">
            <p class="desc">Name your favorite four letter word?</p>
            <h3 class="heading_yeelow">Hmm --- FREE?</h3>
            <p class="heading_large">Are you rebranding or branding your establishment? Allow us to give you a detail pivoting map on rebranding or branding your establishment digitally.

            </p>
            <div class="multiple-arrow">
                <img src="assets/dots.png" class="multiple-arrow" alt="">
            </div>

        </div>
    </div>

</div>